import type { RiskLevel } from "../../lib/api.js";

const COLOR: Record<RiskLevel, string> = {
  high: "var(--risk-high)",
  medium: "var(--risk-medium)",
  low: "var(--risk-low)",
};

export function ScoreBar({ score, riskLevel }: { score: number; riskLevel: RiskLevel }) {
  return (
    <div className="flex items-center gap-2.5 min-w-[100px]">
      <div
        className="flex-1 h-1.5 rounded-full overflow-hidden"
        style={{ background: "var(--border)" }}
      >
        <div
          className="h-full rounded-full transition-all"
          style={{ width: `${score * 100}%`, background: COLOR[riskLevel] }}
        />
      </div>
      <span
        className="font-mono-data text-xs w-8 text-right"
        style={{ color: "var(--text-secondary)" }}
      >
        {(score * 100).toFixed(0)}%
      </span>
    </div>
  );
}
